
/**
 * @license undefined
  * Copyright Google Inc. All Rights Reserved.
  * *
  * Use of this source code is governed by an MIT-style license that can be
  * found in the LICENSE file at https://angular.io/license
 */
export class GeneratedFile {
/**
 * @param {?} srcFileUrl
 * @param {?} genFileUrl
 * @param {?} source
 */
constructor(public srcFileUrl: string,
public genFileUrl: string,
public source: string) {}
}

function GeneratedFile_tsickle_Closure_declarations() {
 /** @type {?} */
GeneratedFile.prototype.srcFileUrl;
 /** @type {?} */
GeneratedFile.prototype.genFileUrl;
 /** @type {?} */
GeneratedFile.prototype.source;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
